module.exports = __webpack_public_path__ + "img/partners-1.e4dc43a4.png";